import { FC, useMemo } from 'react'
import { useRouteError } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './error.css'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'
import Card from '@components/atoms/card'

// UTILITIES
import { isObject } from '@utils/type-checkers'
import { version } from '../../../package.json'
import { platform } from '@utils/capacitor-helper'


interface Props { }

const ErrorBoundary: FC<Props> = () => {
    const error = useRouteError()
    console.error(error)

    const errorText = useMemo(() => {
        if (isObject(error) && error && error instanceof Error) {
            Sentry.captureException(error)
        }

        if (isObject(error) && (!!error.statusText || !!error.message)) return error.statusText || error.message
        else return 'Oops, something went wrong.'
    }, [error])

    return (
        <div className='error-page' id="error-page">
            <div>
                <div className='error-content'>
                    <div className="bubble-md flex items-center justify-center" style={{ alignSelf: 'center', background: 'var(--splitcard-red-100)' }}><Icons.WarningSmall tint="var(--splitcard-red-500)" type='filled' /></div>
                    <h3>{errorText}</h3>
                    <p className='text-body'>Please refresh and try again.</p>
                    <p className='text-body'>If it keeps happening, reach out to Splitcard Support so we can help.</p>
                    <Card style={{ textAlign: 'center' }}>
                        <p className='body2'><strong>Contact Support</strong></p>
                        <div className='flex flex-row items-center justify-center gap-2'>
                            <Icons.Phone tint='var(--splitcard-blue-500)' height={'1rem'} width={'1rem'} />
                            <a onClick={() => window.open("tel:+18886254349")}>888-625-4349</a>
                        </div>
                        <div className='flex flex-row items-center justify-center gap-2'>
                            <Icons.Email tint='var(--splitcard-blue-500)' height={'1rem'} width={'1rem'} />
                            <a onClick={() => window.open("mailto:support@splitcard.com")}>support@splitcard.com</a>
                        </div>
                    </Card>
                    {(platform !== 'web') && <p className="text-body-2 text-gray-500">Version: {version}</p>}
                    <Button onClick={() => window.location.reload()} style={{ marginTop: '0.5rem' }}>Refresh Page</Button>
                </div>
            </div>
        </div>
    )
}

export default ErrorBoundary
